import { queryOptions } from '@tanstack/react-query'

import { fetchTicketTypes } from '#admin/features/ticket-types/api.ts'

// Under `['ticket']`, so a payment that issues tickets refreshes the sold counts with everything else.
export const ticketTypesQuery = () =>
  queryOptions({
    queryKey: ['ticket', 'ticket-types'],
    queryFn: ({ signal }) => fetchTicketTypes(signal),
    staleTime: 60_000,
  })
